import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { LabelsDataService } from '@services/labels-data.service';
import { AbstractFormControlComponent } from '../abstract-form-control.component';
import { NameFormControl } from './name-form-control';

@Component({
  standalone: false,
  selector: 'app-name-form-control',
  templateUrl: './name-form-control.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameFormControlComponent),
      multi: true
    }
  ]
})
export class NameFormControlComponent
  extends AbstractFormControlComponent<NameFormControl>
  implements OnInit, ControlValueAccessor
{
  @Input() override parentForm: FormGroup = new FormGroup({});
  @Input() override formControlName: string = undefined;
  @Input() override title: string = undefined;

  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  requiredText: string = '';
  onChanged: any = (value: string) => {};
  faCheck: any = faCheck;

  constructor(public labelsDataService: LabelsDataService) {
    super();
  }

  ngOnInit(): void {
    this.requiredText = this.labelsDataService.getData('COMMON.PleaseFillInThisFieldText');
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public writeValue(value: any): void {}

  public get maxLength(): number {
    return this.control.maxLength;
  }

  public get capitalizeAll(): boolean {
    return this.control.capitalizeAll || false;
  }

  public get readOnlyCss(): boolean {
    return this.control.readOnlyCss || false;
  }

  public get hideSuccessMark(): boolean {
    return this.control.hideSuccessMark || false;
  }
}
